export interface MovieCollection {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  cover: string;
  movieIds: string[];
  count: number;
}

export const collections: MovieCollection[] = [
  {
    id: 'c001',
    title: '金石碑刻里的汉字秘辛',
    subtitle: '考古 · 悬疑 · 历史',
    description: '从碑文、拓片到一方旧砚，看汉字如何在石刻与器物中承载被时间掩埋的往事。',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20stone%20inscriptions%20and%20ink%20rubbings%20arranged%20on%20a%20dark%20scholarly%20table%2C%20solemn%20navy%20and%20stone%20grey%20palette%2C%20mysterious%20mood&width=1200&height=900&seq=collection-001&orientation=landscape',
    movieIds: ['m003', 'm008', 'm005'],
    count: 3,
  },
  {
    id: 'c002',
    title: '家书与书信里的汉字温度',
    subtitle: '爱情 · 年代 · 温情',
    description: '一封封手写书信，是汉字最私密也最动人的形态。收录以书信为叙事核心的作品。',
    cover: 'https://readdy.ai/api/search-image?query=Stack%20of%20old%20handwritten%20Chinese%20letters%20tied%20with%20red%20thread%20on%20a%20wooden%20table%2C%20warm%20amber%20light%2C%20nostalgic&width=1200&height=900&seq=collection-002&orientation=landscape',
    movieIds: ['m001', 'm010', 'm007'],
    count: 3,
  },
  {
    id: 'c003',
    title: '笔墨纸砚 · 文房四宝特辑',
    subtitle: '书画 · 非遗 · 文化',
    description: '围绕书写工具与汉字的共生关系，精选展现书法与匠艺之美的影视作品。',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20calligraphy%20tools%20with%20brush%20ink%20paper%20and%20stone%20on%20a%20desk%2C%20warm%20lighting%2C%20refined%20composition&width=1200&height=900&seq=collection-003&orientation=landscape',
    movieIds: ['m005', 'm006', 'm009'],
    count: 3,
  },
];

export const getCollectionById = (id: string): MovieCollection | undefined =>
  collections.find((collection) => collection.id === id);